<script setup lang="ts">
import {
    SearchResultReasonDocument,
    SearchResultSupportRequestDocument,
    type SearchResultSupportRequestMutationVariables,
} from '@schema/directus';
import type { SelectItemType } from '#imports';

const { reasonId } = defineProps<{
    reasonId: string;
}>();

const emit = defineEmits<{
    close: [success?: boolean];
}>();

const request = ref<SearchResultSupportRequestMutationVariables>({
    Description: '',
    FirstName: '',
    LastName: '',
    Mobile: '',
    Reason: 0,
});

const authStore = useAuthStore();
const { userInfo } = storeToRefs(authStore);

const { result } = useQuery(SearchResultReasonDocument);
const { mutate } = useMutation(SearchResultSupportRequestDocument);
const reasons = computed<SelectItemType<number>[]>(
    () =>
        result.value?.SearchResultReason.map(reason => ({
            id: +reason.id || 0,
            label: reason.Title || '',
        })) || []
);

onMounted(() => {
    request.value = {
        Description: '',
        FirstName: userInfo.value?.title || '',
        LastName: userInfo.value?.lastName || '',
        Mobile: userInfo.value?.mobile || '',
        Reason: +reasonId,
    };
});

async function submit() {
    try {
        await mutate(request.value);
        await swal({
            title: 'تیکت پشتیبانی شما با موفقیت ثبت شد!',
            text: 'کارشناسان ما پس از بررسی موضوع، نتیجه را از طریق پیامک به شما اطلاع‌رسانی خواهند کرد.',
            icon: 'success',
            confirmButtonText: 'متوجه شدم',
        });
        emit('close', true);
    } catch (e) {
        handleException(e);
    }
}
</script>

<template>
    <mr-modal width="500px" mobile-page title="پشتیبانی" @close="emit('close')">
        <form class="support-form" @submit.prevent="submit">
            <mr-typography weight="500">
                با تکمیل اطلاعات زیر، کارشناسان ما را از مشکل ایجاد شده مطلع
                کنید:
            </mr-typography>
            <div class="row">
                <mr-select
                    v-model="request.Reason"
                    placeholder="موضوع"
                    hide-description
                    :options="reasons"
                    full-width
                />
            </div>
            <div class="row">
                <div class="half-row">
                    <mr-input
                        v-model="request.FirstName"
                        placeholder="نام"
                        hide-description
                    />
                </div>
                <div class="half-row">
                    <mr-input
                        v-model="request.LastName"
                        placeholder="نام خانوادگی"
                        hide-description
                    />
                </div>
            </div>
            <div class="row">
                <mr-input
                    v-model="request.Mobile"
                    placeholder="شماره موبایل"
                    hide-description
                />
            </div>
            <div class="row">
                <mr-input
                    v-model="request.Description"
                    placeholder="توضیحات"
                    hide-description
                    text-area
                    full-width
                />
            </div>
        </form>
        <template #footer>
            <div class="row">
                <mr-button full-width variant="bordered" @click="emit('close')">
                    بازگشت
                </mr-button>
                <mr-button full-width @click="submit">ثبت تیکت</mr-button>
            </div>
        </template>
    </mr-modal>
</template>

<style lang="scss" scoped>
.row {
    flex-basis: 100%;
    display: flex;
    gap: 12px;
    .half-row {
        flex-basis: calc(50% - 6px);
    }
}
.support-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
</style>
